module.exports = __webpack_public_path__ + "img/icon-type-2.20c8d2e5.png";